import angular from 'angular';

export default class UserAcceptablePaymentTerms {
  constructor($scope, $rootScope, UserAcceptablePaymentTermService) {
    $scope.save_terms = function() {
      $scope.updating_terms = true;

      var user_terms = [];
      angular.forEach($scope.terms, function(term) {
        if (term.checked)
          user_terms.push(term.id);
      });

      UserAcceptablePaymentTermService.update($scope.user_id, user_terms).then(function(data) {
        if (data.success) {
          $scope.updating_terms = false;
          var section = window.is_buyer ? 3 : 0;
          var page = window.is_buyer ? 3 : 5;
          $rootScope.$broadcast('set_sidebar_data', [section, page, [{
            type: 'counter',
            value: user_terms.length
          }]]);
        }
      });
    };

    $scope.init = function() {
      $scope.user_id = window.user_id;
      $scope.terms = window.terms;
    };

    $scope.init();

  }
}

UserAcceptablePaymentTerms.$inject = ['$scope', '$rootScope', 'UserAcceptablePaymentTermService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-acceptable-payment-terms.ctrl.js